/* TB V9.19/V9.20 Geschäftskunden-Anfrage (Produktseite)
   Auslöser: snippets/tb-b2b.liquid (Zeile unter dem Preis). Öffnet das Formular der App tb-forms über deren
   öffentliche JavaScript-API TBForms.open() und übergibt Produkt + aktuell gewählte Variante + Menge.
   Die App lädt erst beim ersten Klick (forms.js beobachtet danach das ganze DOM – das soll nicht jeden Besuch kosten).
   Aussehen von Fenster + Formular: Custom CSS in der App (tb-forms-b2b-custom.css, V9.20), nicht mehr aus dem Theme.
   Ohne App / bei Fehler: Hinweis + Link zur E-Mail (data-fallback). */
(function () {
  'use strict';
  if (window.TBb2b) return;
  var loading = null;

  function cfgOf(box) {
    var d = {};
    try { d = JSON.parse((box.querySelector('script[data-tb-b2b-data]') || {}).textContent || '{}'); } catch (e) { d = {}; }
    return d;
  }

  /* Test-Modus: Zeile nur sichtbar mit ?tbb2b=1 in der Adresse oder im Theme-Editor */
  function reveal() {
    var test = /[?&]tbb2b=1\b/.test(location.search) || (window.Shopify && Shopify.designMode);
    document.querySelectorAll('[data-tb-b2b][data-mode="test"]').forEach(function (b) { if (test) b.hidden = false; });
  }

  function loadForms(src) {
    if (window.TBForms && typeof window.TBForms.open === 'function' && !window.TBForms.__stub) return Promise.resolve();
    if (loading) return loading;
    loading = new Promise(function (ok, no) {
      var s = document.createElement('script');
      s.src = src; s.defer = true;
      s.onload = function () { (window.TBForms && window.TBForms.open) ? ok() : no(new Error('TBForms fehlt')); };
      s.onerror = function () { no(new Error('forms.js nicht geladen')); };
      document.head.appendChild(s);
    }).catch(function (e) { loading = null; throw e; });
    return loading;
  }

  /* Variante, die gerade im Kauf-Formular gewählt ist (nicht die vom Seitenaufbau) */
  function liveVariantId(d) {
    var f = document.querySelector('#main-product form.f8pr-buy-button [name="id"]') ||
            document.querySelector('form[action*="/cart/add"]:not(.f8pr-product-form-installment) [name="id"]');
    var v = f && f.value;
    if (!v) { var m = location.search.match(/[?&]variant=(\d+)/); v = m && m[1]; }
    return String(v || d.variant || '');
  }
  function qty() {
    var q = document.querySelector('#main-product form.f8pr-buy-button [name="quantity"]') ||
            document.querySelector('form[action*="/cart/add"] [name="quantity"]');
    var n = q ? parseInt(q.value, 10) : 0;
    return n > 0 ? n : 1;
  }

  function context(d) {
    var vid = liveVariantId(d);
    var v = (d.variants || []).filter(function (x) { return String(x.id) === vid; })[0] || (d.variants || [])[0] || {};
    var variant = { variantId: String(v.id || vid || '') };
    if (v.title && v.title !== 'Default Title') variant.variantTitle = v.title;
    if (v.sku) variant.sku = v.sku;
    if (v.barcode) variant.ean = v.barcode;
    return {
      source: 'product_page',
      pageType: 'product',
      product: { productId: String(d.id || ''), productTitle: d.title || '', productUrl: location.origin + (d.url || location.pathname), quantity: qty() },
      variant: variant
    };
  }


  /* V9.21 Handy: Fenster nach unten wischen schließt – wie unsere anderen Blätter (tb-sections.js initSheets, gleiche Schwellen).
     Greift am Kopf (oberste 64 px) oder überall, solange das Formular ganz oben steht. Eingabefelder bleiben normal bedienbar. */
  var MQ = window.matchMedia ? window.matchMedia('(max-width: 760px)') : { matches: false };
  var NO = 'input,select,textarea,[contenteditable]';
  function outCubic(k) { return 1 - Math.pow(1 - k, 3); }
  function outQuint(k) { return 1 - Math.pow(1 - k, 5); }
  function bindDrag() {
    var roots = document.querySelectorAll('.tb-popup-root');
    var root = roots[roots.length - 1];
    var sr = root && root.shadowRoot;
    if (!sr || sr.__tbDrag) return;
    var modal = sr.querySelector('.tb-popup'), ovl = sr.querySelector('.tb-popup-overlay'), sc = sr.querySelector('.tb-popup__content');
    if (!modal || !ovl) return;
    sr.__tbDrag = 1;
    var bg = getComputedStyle(ovl).backgroundColor, m = bg.match(/rgba?\(([^)]+)\)/), parts = m ? m[1].split(',') : null;
    var base = parts && parts.length === 4 ? parseFloat(parts[3]) : .45, rgb = parts ? parts.slice(0, 3).join(',') : '20,20,32';
    var S = null, raf = 0;
    function shade(d, h) { ovl.style.setProperty('background-color', 'rgba(' + rgb + ',' + Math.max(0, base * (1 - d / (h * 1.1))).toFixed(3) + ')', 'important'); }
    function paint() { raf = 0; if (!S || S.lock !== 1) return; modal.style.setProperty('transform', 'translate3d(0,' + S.d.toFixed(1) + 'px,0)', 'important'); shade(Math.max(0, S.d), S.h); }
    function clean() { modal.style.removeProperty('transform'); modal.style.removeProperty('will-change'); ovl.style.removeProperty('background-color'); }
    function tween(from, to, ms, ease, done) {
      var t0 = 0;
      function f(t) { if (!t0) t0 = t; var k = Math.min(1, (t - t0) / ms), y = from + (to - from) * ease(k);
        modal.style.setProperty('transform', 'translate3d(0,' + y.toFixed(1) + 'px,0)', 'important'); shade(Math.max(0, y), modal.offsetHeight || 600);
        if (k < 1) requestAnimationFrame(f); else done(); }
      requestAnimationFrame(f);
    }
    sr.addEventListener('touchstart', function (e) {
      S = null;
      if (!MQ.matches || e.touches.length !== 1) return;
      var t = e.composedPath ? e.composedPath()[0] : e.target;
      var path = e.composedPath ? e.composedPath() : [];
      if (!t || !t.closest || path.indexOf(modal) < 0) return;
      var y = e.touches[0].clientY, head = y - modal.getBoundingClientRect().top < 64;
      if (!head && t.closest(NO)) return;
      if (!head && sc && sc.scrollTop > 0) return;
      S = { x0: e.touches[0].clientX, y0: y, d: 0, lock: 0, h: modal.offsetHeight || 600, hist: [[e.timeStamp, y]] };
    }, { passive: true });
    sr.addEventListener('touchmove', function (e) {
      if (!S) return;
      var x = e.touches[0].clientX, y = e.touches[0].clientY, dx = x - S.x0, dy = y - S.y0;
      if (S.lock === 0) {
        if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
        if (Math.abs(dx) > Math.abs(dy) || dy < 0 || (sc && sc.scrollTop > 0)) { S = null; return; }
        S.lock = 1; S.y0 = y; dy = 0; modal.style.setProperty('will-change', 'transform');
        var ae = sr.activeElement; if (ae && ae.blur) ae.blur();
      }
      if (e.cancelable) e.preventDefault();
      S.d = dy < 0 ? dy * .2 : dy; S.hist.push([e.timeStamp, y]); if (S.hist.length > 6) S.hist.shift();
      if (!raf) raf = requestAnimationFrame(paint);
    }, { passive: false });
    function end() {
      if (!S) return; var s = S; S = null; if (s.lock !== 1) return; if (raf) { cancelAnimationFrame(raf); raf = 0; }
      var a = s.hist[0], b = s.hist[s.hist.length - 1], v = (b[1] - a[1]) / Math.max(16, b[0] - a[0]);
      if (s.d > Math.min(140, s.h * .3) || (v > .45 && s.d > 16)) {
        var to = s.h + 24, ms = Math.round(Math.max(180, Math.min(300, (to - s.d) / Math.max(v, 1.6))));
        tween(s.d, to, ms, outCubic, function () { if (window.TBForms && TBForms.close) TBForms.close(); });
      } else {
        tween(s.d, 0, 340, outQuint, clean);
      }
    }
    sr.addEventListener('touchend', end, { passive: true });
    sr.addEventListener('touchcancel', end, { passive: true });
  }

  function open(btn) {
    var box = btn.closest('[data-tb-b2b]');
    if (!box) return;
    var d = cfgOf(box);
    btn.setAttribute('aria-busy', 'true');
    btn.classList.add('is-busy');
    var done = function () { btn.removeAttribute('aria-busy'); btn.classList.remove('is-busy'); };
    loadForms(box.getAttribute('data-src')).then(function () {
      window.TBForms.open(box.getAttribute('data-form'), context(d));
      try { bindDrag(); } catch (e) {}
      done();
    }).catch(function () {
      done();
      var fb = box.querySelector('[data-tb-b2b-fallback]');
      if (fb) fb.hidden = false;
    });
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-tb-b2b-open]');
    if (!b) return;
    e.preventDefault();
    open(b);
  });
  /* Vorladen bei Absicht (Maus drüber / Finger drauf): Fenster öffnet dann ohne Wartezeit */
  ['pointerenter', 'touchstart', 'focusin'].forEach(function (ev) {
    document.addEventListener(ev, function (e) {
      var b = e.target.closest && e.target.closest('[data-tb-b2b-open]');
      if (!b) return;
      var box = b.closest('[data-tb-b2b]');
      if (box) loadForms(box.getAttribute('data-src')).catch(function () {});
    }, { capture: true, passive: true });
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', reveal); else reveal();
  window.TBb2b = { open: open };
})();
